module.exports = __webpack_public_path__ + "img/registra-tu-ticket-y suma-goles.32997306.png";